//mandatory
export var DrawerLevelPositionTypes;
(function (DrawerLevelPositionTypes) {
    DrawerLevelPositionTypes["FIRST_LEVEL"] = "FIRST_LEVEL";
    DrawerLevelPositionTypes["SECOND_LEVEL"] = "SECOND_LEVEL";
})(DrawerLevelPositionTypes || (DrawerLevelPositionTypes = {}));
//# sourceMappingURL=level.js.map